import { apiRequest } from './client';
import type { Activation, BusinessOffering, OnboardingClientEvent } from '../types/onboarding';

// ONB-001 (Macrofase A) — guía de activación del negocio guiado. Solo el dueño (el backend lo exige y
// responde 403 a cualquier otro rol). Un negocio anterior responde `guided: false` y nada más.
export const getActivation = () => apiRequest<Activation>('/api/onboarding/activation');
export const setOffering = (offering: BusinessOffering) =>
  apiRequest<Activation>('/api/onboarding/offering', { method: 'PUT', body: JSON.stringify({ offering }) });
export const dismissActivation = () =>
  apiRequest<Activation>('/api/onboarding/activation/dismiss', { method: 'POST', body: JSON.stringify({}) });

// P-085 (Codex R1, K5): «Lo haré después» en el primer artículo se GUARDA en el servidor antes de seguir.
export const skipFirstItem = () =>
  apiRequest<Activation>('/api/onboarding/first-item/skip', { method: 'POST', body: JSON.stringify({}) });

// P-085: un evento del embudo que solo la app sabe (abrir el punto de venta, un error de pantalla). De mejor esfuerzo:
// nunca lanza ni cambia lo que la persona ve; el servidor responde 204 siempre.
export function recordOnboardingEvent(input: OnboardingClientEvent): void {
  void apiRequest<void>('/api/onboarding/events', { method: 'POST', body: JSON.stringify(input) }).catch(() => undefined);
}
